/**
 * Global page-switch fade for every top-nav navigation. A background-coloured layer is
 * placed under the nav synchronously on click (before the route renders), holds briefly
 * while the new page settles, then fades out. Independent of component remounts, so it
 * also works for same-route clicks and Home-section jumps.
 */
let cover: HTMLDivElement | null = null;

export function playRouteFade() {
  if (cover) cover.remove();
  const el = document.createElement('div');
  el.className = 'route-enter-cover';
  el.setAttribute('aria-hidden', 'true');
  el.addEventListener('animationend', () => {
    el.remove();
    if (cover === el) cover = null;
  });
  document.body.appendChild(el);
  cover = el;
}